// Yorstruly başlangıç tasarımlarındaki ürünler — Shopify 26 Eki 2026 anlık görüntüsü
// (fiyatlar stüdyoda güncellenebilir). Üreteç: glowytics-backend/var/yorstruly_email/products.py
const PR = {
 "RISER_MERLOT": {
  "title": "RISER 7/8 LEGGINGS - MERLOT",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/riser-7-8-leggings-merlot",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/RISERPANTSveDOUBLEUPBRAMERLOTTAMBOYON_3cd5779d-1639-44e6-8a11-6fbf2f83d931.jpg?v=1791209938",
  "price": 3650,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/89fec75b26959ede9fd6.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_a7606b21b874ca9b.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_e17da2cb77a5.jpg"
 },
 "COCO_MERLOT": {
  "title": "COCO BRA - MERLOT",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/coco-bra-merlot",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/COCOBRAMERLOTYARIM.BOY2.jpg?v=1791209675",
  "price": 2250,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/869ee428cbfef9ce339a.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_a52b0c3b03d498c5.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_4dadb7c8d3c4.jpg"
 },
 "MERROW_EB": {
  "title": "MERROW LEGGING - ELECTRIC BLUE",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/merrow-legging-electric-blue",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/SKINNY_BRA_ELECTRIC_BLUE_VE_MERROW_LEGGINGS_ELECTRIC_BLU_E_ON_TAM_BOY.jpg?v=1791214565",
  "price": 2950,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/f31dfc2a55c20ca76535.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_dd0c60eb774b581e.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_32549867dee3.jpg"
 },
 "BLOOM_EB": {
  "title": "BLOOM SPORTS BRA - ELECTRIC BLUE",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/bloom-skyline-sports-bra",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/BLOOM_BRA_ELECTRIC_BLUE_ON.jpg?v=1791214623",
  "price": 2595,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/b56aed0e5bfc6fe2b7f0.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_711cb452b574ec33.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_f99e07c081c2.jpg"
 },
 "TWIST_GANACHE": {
  "title": "TWIST FLARE PANTS - CHOCOLATE GANACHE",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/twist-flare-pants-ganache",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/TWISTPANTSGANACHE.jpg?v=1791209856",
  "price": 3650,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/1b12337ea5f1e8730d54.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_30f609c3f570c6d6.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_055a129a322a.jpg"
 },
 "GAIA_GANACHE": {
  "title": "GAIA BRA - CHOCOLATE GANACHE",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/gaia-bra-ganache",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/GAIABRAGANACHEONYARIMBOY.jpg?v=1791209616",
  "price": 2295,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/2a8663cd74bfbc16809b.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_98c05fb862c50b53.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_276be5199277.jpg"
 },
 "TWIST_LEO": {
  "title": "TWIST FLARE PANTS - LEOPARD",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/twist-flare-pants-leopard",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/LEOPARTAKIMTAMBOY.jpg?v=1791208824",
  "price": 3450,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/5b6bdc5a1c3926ffb055.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_0a3eb63b96df7025.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_eba41b175f77.jpg"
 },
 "GAIA_LEO": {
  "title": "GAIA BRA - LEOPARD",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/gaia-bra-leopard-1",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/GAIABRALEOPARONYARIMBOY.jpg?v=1791208945",
  "price": 2250,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/5fd50ba23ae9f7b744d1.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_f4ff26453826961c.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_14493c54bc43.jpg"
 },
 "MERROW_LEO": {
  "title": "MERROW LEGGINGS - LEOPARD",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/merrow-leggings-leopard",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/MERROWLEGGING-LEOPARD.png?v=1767899933",
  "price": 2999,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/51eb83a430f35b9cfae5.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_a41438eca6c69abe.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_af71e60daf26.jpg"
 },
 "STUDIO_LEO": {
  "title": "STUDIO PANTS - LEOPARD",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/studio-pants-leopard",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/YoursTruly_Lookbook_19_09_25_1951.jpg?v=1762506501",
  "price": 2599,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/68983754f450f6c7d306.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_4d904246ab8d2352.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_2606389b2a69.jpg"
 },
 "STUDIO_MERLOT": {
  "title": "STUDIO PANTS - MERLOT",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/studio-pants-merlot",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/IMG-6447.png?v=1792425541",
  "price": 2290,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/90954b3b30d1b774dee9.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_38e9387e51025851.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_1ed93da6187f.jpg"
 },
 "SKINNY_ESP": {
  "title": "SKINNY BRA - ESPRESSO MARTINI",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/skinny-bra-espresso-martini",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/AWSS25_164_cfabcd3e-5763-4d94-8c9c-975a9df581b7.png?v=1764593764",
  "price": 1799,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/6d1d06d637e428db25f4.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_b17d15bc65e405ce.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_fb79f2ff9227.jpg"
 },
 "SET1": {
  "title": "SET 1 - BLOOM BRA - RISER LEGGINGS",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/set-1-bloom-riser",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/RISER_LEGGINGS_VE_BLOOM_BRA_ON_TAM_BOY.jpg?v=1791214721",
  "price": 5308,
  "listPrice": 6245,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/4face785deede04d4cf8.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_efc9291616adbcdf.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_4b71152053f1.jpg"
 },
 "SET5": {
  "title": "SET 5 - CUT OUT BRA - MERROW LEGGING",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/set-5-cut-out-bra-merrow-legging-fire",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/Y.OURSTRULY_059_2563_8a2069f3-cf1c-429e-a289-3cd613568ede.jpg?v=1791461800",
  "price": 4758,
  "listPrice": 5598,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/fb384ab8e62656cdc01a.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_9d130bfa915872d5.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_6b165bc7dd90.jpg"
 },
 "CURVE_MERLOT": {
  "title": "CURVE MERINO KAPÜŞONLU FERMUARLI CEKET-MERLOT",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/curve-merino-kapusonlu-fermuarli-ceket-merlot",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/MERINOHOODIEMERLOTONTAMBOY.png?v=1791219288",
  "price": 3595,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/a805e4bcbf0358094041.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_4d12118632278bb8.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_4ec738060f4a.jpg"
 },
 "BALLET_WRAP_GANACHE": {
  "title": "MERINO BALLET WRAP - CHOCOLATE GANACHE",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/merino-ballet-wrap-ganache",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/MERINOWRAPGANACHEONYARIMBOY_d35254ae-7e5e-4323-a48a-1329068ea693.jpg?v=1791210336",
  "price": 2350,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/16e8d7c3d3be65d26aa5.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_cc09e922ec148fe8.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_4efe57465d31.jpg"
 },
 "BALLET_TOP_MERLOT": {
  "title": "MERINO BALLET TOP - MERLOT",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/merino-ballet-top-merlot",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/MERINOBALLETTOPMERLOTONYARIMBOY.jpg?v=1791206994",
  "price": 2255,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/19e4e82c4b50c2b4ac12.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_70d03bfb0009d508.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_8e57f0740fc2.jpg"
 },
 "OFFSH_GANACHE": {
  "title": "MERINO OFF-SHOULDER - CHOCOLATE GANACHE",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/merino-off-shoulder-chocolate-ganache",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/DE99350D-1361-4AD9-8614-4AE9614F817E_ad8caebf-d52f-4363-9d97-203f360cdd7f.png?v=1791823472",
  "price": 4250,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/c936ca7adac0b6c6fa55.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_faa7f6871979fe84.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_01bd11dc52c9.jpg"
 },
 "LEG_WARM": {
  "title": "MERINO LAYER LEG WARMERS - CHARCOAL",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/merino-layer-leg-warmers-charcoal",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/AWSS25_111.png?v=1773741912",
  "price": 1450,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/caa2224780a103b4fae0.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_f99fbf20044eebf6.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_1165d477bdcf.jpg"
 },
 "JUMP_GANACHE": {
  "title": "CRISS-CROSS JUMPSUIT - CHOCOLATE GANACHE",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/criss-cross-jumpsuit-ganache",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/CRISSCROSSTULUMGANACHEONTAMBOY.jpg?v=1791209060",
  "price": 5650,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/ef8090791ac10f3b1a91.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_c6d405b1569d27ef.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_76b89a308e81.jpg"
 },
 "POLO_NAVY": {
  "title": "BUTTER POLO KNIT NAVY",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/butter-polo-knit-navy",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/IMG-6503_b9807aa8-d1e2-49a7-bdc4-22deb58c1f16.png?v=1792595471",
  "price": 3450,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/537c2a1a52ff397ee6bc.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_1be2f77d7eea0a80.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_d2989e73fd16.jpg"
 },
 "NAKED_BRA": {
  "title": "NAKED BRA - TAUPE",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/naked-bra-taupe",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/NAKEDBRA-TAUPE.jpg?v=1733414002",
  "price": 1599,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/6fc7fd1580a7363a841d.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_62a6f495d807628c.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_ab067ac7c8c9.jpg"
 },
 "FAIR_TEE": {
  "title": "F'AIR T-SHIRT KISA KOLLU - BEYAZ",
  "color": "",
  "brand": "",
  "url": "https://yorstruly.com/products/pure-touch-tee-t-shirt-white",
  "image": "https://cdn.shopify.com/s/files/1/2192/8361/files/261.png?v=1773154799",
  "price": 1899,
  "listPrice": null,
  "jpg": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/255bdc1a0629b195ae8c.jpg",
  "jpgWide": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/pair_853ba817dc17a102.jpg",
  "jpgTall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/tall_50f8c311662f.jpg"
 }
};

// Kampanya fotoğrafları: cover = 1200 genişlik (dikeyse 4:5), tall = 600x800
export const LIFE = {
 "LOFT": {
  "cover": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/life_loft_d2b3c0f1b1b9.jpg",
  "tall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/lifet_loft_156d1543aab0.jpg"
 },
 "TRIO_WIDE": {
  "cover": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/life_trio_wide_0d63589bcc76.jpg",
  "tall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/lifet_trio_wide_3af1daf32bcc.jpg"
 },
 "TRIO_TALL": {
  "cover": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/life_trio_tall_7f89bb779b03.jpg",
  "tall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/lifet_trio_tall_8d8c719c9696.jpg"
 },
 "GANACHE_WIDE": {
  "cover": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/life_ganache_wide_70b75127e0f1.jpg",
  "tall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/lifet_ganache_wide_ef6f95a05804.jpg"
 },
 "SUMMER": {
  "cover": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/life_summer_3a38ef9920a4.jpg",
  "tall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/lifet_summer_0d553574b183.jpg"
 },
 "MERLOT_OFF": {
  "cover": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/life_merlot_off_7bf4f53e193b.jpg",
  "tall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/lifet_merlot_off_768b0939a23f.jpg"
 },
 "GANACHE_OFF": {
  "cover": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/life_ganache_off_7ff3fe7a4e93.jpg",
  "tall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/lifet_ganache_off_b90d1e636fbe.jpg"
 },
 "BACK": {
  "cover": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/life_back_4550c33b652f.jpg",
  "tall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/lifet_back_ac9c513277d5.jpg"
 },
 "LEOPARD": {
  "cover": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/life_leopard_3078ddd20bb7.jpg",
  "tall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/lifet_leopard_2c001e47df94.jpg"
 },
 "COCO": {
  "cover": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/life_coco_9b623c473e2f.jpg",
  "tall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/lifet_coco_15d8fd41115c.jpg"
 },
 "HOODIE": {
  "cover": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/life_hoodie_ad9be7072064.jpg",
  "tall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/lifet_hoodie_11864ee84b19.jpg"
 },
 "GAIA_LEO": {
  "cover": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/life_gaia_leo_2db92e394d12.jpg",
  "tall": "https://api.glowytics.com/pixel/glowymail/443c357b-fde2-434e-bb19-34b7898d4576/lifet_gaia_leo_958cfe4c6cab.jpg"
 }
};

export default PR;
